import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { TimerProvider } from "@/context/TimerContext";
import { Toaster } from "@/components/ui/sonner";

import Login from "@/pages/Login";
import AcceptInvite from "@/pages/AcceptInvite";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import Tasks from "@/pages/Tasks";
import Team from "@/pages/Team";
import AuditLogs from "@/pages/AuditLogs";
import Reports from "@/pages/Reports";
import Settings from "@/pages/Settings";
import TaskBenchmarks from "@/pages/TaskBenchmarks";
import Leaderboard from "@/pages/Leaderboard";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TimerProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/accept-invite/:token" element={<AcceptInvite />} />
            <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="projects" element={<Navigate to="/tasks" replace />} />
              <Route path="projects/:id" element={<ProjectDetail />} />
              <Route path="clients" element={<Clients />} />
              <Route path="clients/:id" element={<ClientDetail />} />
              <Route path="tasks" element={<Tasks />} />
              <Route path="time" element={<Navigate to="/tasks" replace />} />
              <Route path="team" element={<ProtectedRoute roles={["admin", "super_admin"]}><Team /></ProtectedRoute>} />
              <Route path="leaderboard" element={<Leaderboard />} />
              <Route path="audit" element={<ProtectedRoute roles={["admin", "super_admin"]}><AuditLogs /></ProtectedRoute>} />
              <Route path="reports" element={<ProtectedRoute roles={["admin", "super_admin"]}><Reports /></ProtectedRoute>} />
              <Route path="settings" element={<Settings />} />
              <Route path="settings/benchmarks" element={<TaskBenchmarks />} />
            </Route>
          </Routes>
        </TimerProvider>
      </BrowserRouter>
      <Toaster richColors position="top-right" />
    </AuthProvider>
  );
}
